import Vue from 'vue/dist/vue.esm.js';
import NewsletterClient from "../clients/NewsletterClient";
import ValidationUtility from "../utility/ValidationUtility";

Vue.component('newsletter-form', {
    template: '#newsletter-form',
    delimiters: ['[[', ']]'],
    props: {
        context: {
            required: true,
            type: String,
        }
    },
    data()
    {
        return {
            email: "",
            isSubmittingEmail: false,
            isEmailInvalid: false,
            isEmailSuccess: false,
            isEmailWarning: false,
            isEmailError: false,

            phone: "",
            isSubmittingPhone: false,
            isPhoneInvalid: false,
            isPhoneSuccess: false,
            isPhoneError: false,
        };
    },
    mounted()
    {

    },
    methods:
    {
        HandleEmailKeyDown(e)
        {
            if(e.key === "Enter" && !this.isSubmittingEmail)
            {
                this.HandleEmailSubmitAsync();
            }
        },
        HandlePhoneKeyDown(e)
        {
            if(e.key === "Enter" && !this.isSubmittingPhone)
            {
                this.HandlePhoneSubmitAsync();
            }
        },
        async HandleEmailSubmitAsync()
        {
            if(!ValidationUtility.IsEmailValid(this.email))
            {
                this.isEmailInvalid = true;
                this.$forceUpdate();
                return;
            }

            this.isEmailInvalid = false;
            this.isEmailSuccess = false;
            this.isEmailWarning = false;
            this.isEmailError = false;
            this.isSubmittingEmail = true;
            this.$forceUpdate();

            try {
                let client = new NewsletterClient();
                let { status } = await client.SubscribeEmailAsync(this.email, this.context);

                if (status === 200 || status === 201) {
                    this.isEmailSuccess = true;
                } else {
                    this.isEmailError = true;
                }
            } catch (err) {
                this.isEmailError = true;
            } finally {
                this.isSubmittingEmail = false;
                this.$forceUpdate();
            }
        },
        async HandlePhoneSubmitAsync()
        {
            if(!ValidationUtility.IsPhoneNumberValid(this.phone))
            {
                this.isPhoneInvalid = true;
                this.$forceUpdate();
                return;
            }

            this.isPhoneInvalid = false;
            this.isPhoneSuccess = false;
            this.isPhoneError = false;
            this.isSubmittingPhone = true;
            this.$forceUpdate();

            try
            {
                let client = new NewsletterClient();
                await client.SubscribePhoneAsync(this.phone, this.context);
            }
            catch(err)
            {
                console.error("Failed to subscribe phone:", err);
                this.isSubmittingPhone = false;
                this.isPhoneError = true;
                this.$forceUpdate();
                return;
            }

            this.isSubmittingPhone = false;
            this.isPhoneSuccess = true;
            this.$forceUpdate();
        }
    }
});